export default "__VITE_ASSET__BOQ4i5Nu__"